module.exports = __webpack_public_path__ + "media/img/favicon-16x16-44dd2fddc335dc2e13142b676e1d7f61.png";